import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register({
  onUpdate: (registration) => {
    window.__DIA_SW_REGISTRATION = registration;
    window.dispatchEvent(
      new CustomEvent('diaSwUpdate', { detail: registration })
    );
  }
});
